module.exports = __webpack_public_path__ + "img/employee-mohammed-okasha.b73a865d.jpg";